/*
 * @Descripttion:
 * @Author: wyx
 * @Date: 2020-09-09 16:45:10
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-16 15:17:52
 */
import Vue from "vue";
import Auth from "@/utils/Auth";
import tool from "@/utils/tool";
import "./common.scss";
import { mapActions } from "vuex";
Vue.prototype.$Tool = tool;

export default {
    data() {
        return {
            Auth,
            //是否正在发送验证码
            isSendingCode: false,
            //验证码当前市场
            codeSecond: 60,
            //验证码计时器
            codeInterval: null,
            priceData: [
                // {
                //     tip: "轻松做运营，仅¥6.42元/天",
                //     price: "199",
                //     originPrice: "399",
                //     unit: "月",
                // },
                // {
                //     tip: "抢购！特惠推荐，满六赠一！",
                //     price: "955",
                //     originPrice: "2394",
                //     unit: "半年",
                // },
                // {
                //     tip: "超值爆款推荐",
                //     price: "1990",
                //     originPrice: "4778",
                //     unit: "年",
                // },
            ],
        };
    },

    methods: {
        ...mapActions("user", {
            sendCode: "sendCode",
            getDcVipLevel:'getDcVipLevel'
        }),

        async priceInfo() {
            //价格列表
            const res = await this.getDcVipLevel();
            if (res.data.errorCode === 200) {
                this.priceData = res.data.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.data.ErrorMessage,
                });
            }
        },


        doScrollFun() {
            let that = this;
            let scrollCon = document.querySelector("#scroll_con");
            var scrollTop = scrollCon.scrollTop;
            var screenHeight = document.body.clientHeight;
            let paddingTop = 80;

            var scrollAnimate = document.querySelectorAll(".scrollAnimate");
            if (!scrollAnimate || scrollAnimate.length === 0) {
                return;
            }
            scrollAnimate.forEach(function(item, i) {
                var duration = item.getAttribute("duration") || 100;
                var top = that.$Tool.getElementTop(item);

                var animate = item.getAttribute("animate") || "fadeIn";
                if (scrollTop + screenHeight >= top + paddingTop) {
                    setTimeout(function() {
                        if (!that.$Tool.hasClass(item, "animated")) {
                            item.style.visibility = "visible";
                            that.$Tool.addClass(item, "animated " + animate);
                        }
                    }, duration);
                }
            });
        },
        async send_sms_code() {
            let pattern = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            let flag = pattern.test(this.form.sPhone);
            if (!flag) {
                this.$message.error("请输入正确的手机号");
                return false;
            }

            this.codeInterval = setInterval(() => {
                if (this.codeSecond > 0) {
                    this.codeSecond--;
                } else {
                    clearInterval(this.codeInterval);
                    this.isSendingCode = false;
                    this.codeSecond = 60;
                }
            }, 1000);
            this.isSendingCode = true;
            
            let res  =  await this.sendCode({sPhone:this.form.sPhone});

            if (res && res.data && res.data.errorCode === 200) {
                this.$message.success("验证码已发送，请注意查收");
            }
            
        }
    },
    beforeDestroy(){
        this.codeInterval && clearInterval(this.codeInterval);
    }
};
